import * as i0 from '@angular/core';
import { input, booleanAttribute, Directive } from '@angular/core';
import * as i1 from 'ng-primitives/autofill';
import { NgpAutofill } from 'ng-primitives/autofill';
import { setupFormControl } from 'ng-primitives/form-field';
import { injectElementRef, setupInteractions } from 'ng-primitives/internal';
import { injectSearchState } from 'ng-primitives/search';
import { uniqueId } from 'ng-primitives/utils';
import { createStateToken, createStateProvider, createStateInjector, createState } from 'ng-primitives/state';

/**
 * The state token  for the Input primitive.
 */
const NgpInputStateToken = createStateToken('Input');
/**
 * Provides the Input state.
 */
const provideInputState = createStateProvider(NgpInputStateToken);
/**
 * Injects the Input state.
 */
const injectInputState = createStateInjector(NgpInputStateToken);
/**
 * The Input state registration function.
 */
const inputState = createState(NgpInputStateToken);
let NgpInput = /*#__PURE__*/(() => {
  class NgpInput {
    constructor() {
      /**
       * The id of the input.
       */
      this.id = input(uniqueId('ngp-input'));
      /**
       * The input may be used within a search field, if so we need to register it.
       */
      this.searchState = injectSearchState({
        optional: true
      });
      /**
       * Access the element reference.
       */
      this.elementRef = injectElementRef();
      /**
       * Whether the element is disabled.
       */
      this.disabled = input(false, {
        transform: booleanAttribute
      });
      /**
       * The input state.
       */
      this.state = inputState(this);
      setupInteractions({
        hover: true,
        press: true,
        focus: true,
        disabled: this.state.disabled
      });
      // Set up the form control with the id and disabled state.
      this.status = setupFormControl({
        id: this.state.id,
        disabled: this.state.disabled
      });
      this.searchState()?.registerInput(this.elementRef.nativeElement);
    }
    static {
      this.ɵfac = function NgpInput_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NgpInput)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: NgpInput,
        selectors: [["input", "ngpInput", ""]],
        hostVars: 2,
        hostBindings: function NgpInput_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵattribute("id", ctx.id())("disabled", ctx.status().disabled ? "" : null);
          }
        },
        inputs: {
          id: [1, "id"],
          disabled: [1, "disabled"]
        },
        exportAs: ["ngpInput"],
        features: [i0.ɵɵProvidersFeature([provideInputState()]), i0.ɵɵHostDirectivesFeature([i1.NgpAutofill])]
      });
    }
  }
  return NgpInput;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { NgpInput, injectInputState, provideInputState };
